import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

import AvatarCard from "../../../../../../components/AvatarCard";
import colors from "../../../../../../theme/colors";

const ReceivablesStatusCard = (): JSX.Element => (
  <AvatarCard
    title="Receivables Status"
    color={colors.orange}
    icon={<FontAwesomeIcon icon={faLock} size="lg" />}
    subheader="FROZEN"
  />
);

export default ReceivablesStatusCard;
